module.exports = __webpack_public_path__ + "img/infra5.60b8b4da.png";